"use client";

import React from "react";
import { useSearchParams } from "next/navigation";
import { cn } from "@utils/utils";
import { FeatureCategory } from "@factories/variantSpecificationsFactory";
import styles from "./SpecificationSection.module.scss";
import Button from "@components/atoms/Button";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";
import { getSelectedCityClient } from "@helpers/client/getSelectedCity";

interface CategoryTabsProps {
  categories: FeatureCategory[];
  selectedCategoryIndex: number;
  selectedVariantId: string;
  pageType?: string;
  brandName?: string;
  modelName?: string;
  variantName?: string;
  carAvailability?: string;
  cityName?: string;
  onCategoryChange: (categoryIndex: number) => void;
}

export const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  selectedCategoryIndex,
  selectedVariantId,
  pageType,
  brandName,
  modelName,
  variantName,
  carAvailability,
  cityName,
  onCategoryChange,
}) => {
  const searchParams = useSearchParams();
  const { name: clientCityName } = getSelectedCityClient();
  const currentCityName = cityName || clientCityName;

  const handleCategoryChange = (categoryIndex: number) => {
    onCategoryChange(categoryIndex);

    const params = new URLSearchParams(searchParams?.toString());
    params.set("category", categoryIndex.toString());
    if (selectedVariantId) {
      params.set("variant", selectedVariantId);
    }
    window.history.pushState(
      null,
      "",
      `${window.location.pathname}?${params.toString()}${window.location.hash}`
    );

    void trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_expand_feature",
        car_availability: carAvailability,
        vehicle_make: brandName,
        vehicle_model: modelName,
        vehicle_variant: variantName,
        city_name: currentCityName,
        feature: categories[categoryIndex].title,
      },
    });
  };

  return (
    <div className={styles.specs__tabs}>
      {categories.map((category, index) => (
        <Button
          key={category.title}
          className={cn(
            styles.specs__tab,
            selectedCategoryIndex === index && styles.specs__tab_active
          )}
          onClick={() => handleCategoryChange(index)}
        >
          {category.title}
        </Button>
      ))}
    </div>
  );
};
